import { useEffect, useState } from "react";

import { phoneNumberSanitation } from "../utils/inputSanitation";
import { useContactsContext } from "../../contexts/ContactsContextProvider";
import { Button, Input } from "@material-tailwind/react";
import { isoTimestampToLocal } from "../utils/timeStampConversion";
import { useUserContext } from "../../contexts/UserContextProvider";

const UpdateContact = ({
  contactInfo,
  setUpdateContact,
  isAddUpdateContact,
}) => {
  const { apiCallUpdateContact, apiCallCreateContactOnBigin } =
    useContactsContext();
  const { currentUserInfo } = useUserContext();
  const [toEditContact, setToEditContact] = useState({});
  const [isSyncingBiginContact, setIsSyncingBiginContact] = useState(false);

  const handleContactEditOnChange = (e) => {
    let { name, value } = e.target;

    if (name === "phoneNo" || name === "countryCode") {
      value = phoneNumberSanitation(value);
    }

    setToEditContact((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleContactsSyncWithBigin = async (e) => {
    setIsSyncingBiginContact(true);
    const contactNumber =
      toEditContact?.CountryCode + "" + toEditContact?.PhoneNumber;
    const name = toEditContact?.FirstName + " " + toEditContact?.LastName;
    const response = await apiCallCreateContactOnBigin({
      contactNumber,
      profileName: name,
    });
    if (response) {
      setIsSyncingBiginContact(false);
    } else {
      setIsSyncingBiginContact(false);
    }
  };

  const handleContactEditOnSubmit = async (e) => {
    e.preventDefault();
    const contactDetails = {
      contactId: toEditContact?.ContactId,
      firstName: toEditContact?.FirstName,
      lastName: toEditContact?.LastName,
      email: toEditContact?.Email,
      waOptIn: toEditContact?.waOptIn,
      isBlocked: toEditContact?.IsBlocked,
      remarks: toEditContact?.Remarks,
      companyName: toEditContact?.CompanyName,
      city: toEditContact?.City,
      country: toEditContact?.Country,
      countryCode: toEditContact?.CountryCode,
      phoneNumber: toEditContact?.PhoneNumber,
    };
    await apiCallUpdateContact(contactDetails);
    setUpdateContact(false);
  };

  useEffect(() => {
    setToEditContact(contactInfo);
  }, [contactInfo, isAddUpdateContact]);

  return (
    <form onSubmit={handleContactEditOnSubmit} className="w-full space-y-5">
      <p className="font-semibold text-xl text-center">Add/Update Contact</p>

      <div className="bg-slate-200 px-5 py-1 flex justify-center items-center gap-2 rounded-md">
        <p>Phone Number :</p>
        <p className="font-semibold text-lg">{`+${toEditContact?.CountryCode} ${toEditContact?.PhoneNumber}`}</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {Object.entries(toEditContact).map(([key, value]) =>
          [
            "CreatedBy",
            "IsVerifiedNumber",
            "UpdatedBy",
            "LastContactedBy",
            "MergedContactNumber",
          ]?.includes(key) ? (
            <div key={key} className="bg-blue-50 p-2 space-y-1 rounded-md">
              <p className="text-xs">{key}</p>
              <p>{value === 1 ? "YES" : value === 0 ? "NO" : value}</p>
            </div>
          ) : ["waOptIn", "IsBlocked"]?.includes(key) ? (
            <div
              key={key}
              className="px-2 py-1 flex items-center gap-1 rounded-md border border-slate-200"
            >
              <p className="text-xs">{key}</p>
              <select
                name={key}
                value={value}
                onChange={handleContactEditOnChange}
                className="wbm-select-1"
              >
                <option value="2" hidden ng-disabled="!!model">
                  ~ Not Set ~
                </option>
                <option key="0" value="0">
                  No
                </option>
                <option key="1" value="1">
                  Yes
                </option>
              </select>
            </div>
          ) : ["LastContacted"]?.includes(key) ? (
            <div key={key} className="bg-blue-50 p-2 space-y-1 rounded-md">
              <p className="text-xs">{key}</p>
              <p>{value ? isoTimestampToLocal(value) : "-"}</p>
            </div>
          ) : (
            ![
              "contactData",
              "ContactId",
              "CountryCode",
              "PhoneNumber",
            ]?.includes(key) &&
            key !== "indx" && (
              <div key={key}>
                <Input
                  name={key}
                  label={key}
                  color="blue"
                  value={value || ""}
                  onChange={handleContactEditOnChange}
                />
              </div>
            )
          )
        )}
      </div>
      {toEditContact?.ContactData &&
        Object.keys(toEditContact.ContactData).length > 0 && (
          <div className="h-52 mt-4 p-3 bg-blue-50 rounded-md border border-blue-200">
            <h4 className="text-sm font-semibold mb-2 text-blue-800">
              Contact Data
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {Object.entries(toEditContact.ContactData).map(([key, value]) => (
                <div key={key} className="flex gap-2">
                  <p>{key} : </p>
                  <p>{value || ""}</p>
                </div>
              ))}
            </div>
          </div>
        )}

      <Button type="submit" variant="gradient" color="blue" size="sm">
        Save Edits
      </Button>
      {currentUserInfo?.isBiginIntegrated && (
        <Button
          type="button"
          variant="outline"
          color="green"
          size="sm"
          disabled={isSyncingBiginContact}
          className="ml-4"
          onClick={handleContactsSyncWithBigin}
        >
          Sync with Bigin
        </Button>
      )}
    </form>
  );
};

export default UpdateContact;
